var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"title":_vm.title,"width":800,"placement":"right","closable":false,"visible":_vm.visible},on:{"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }